import React, { useState } from "react";
import "../styles/aichat.css";
import { FiSend } from "react-icons/fi";
import { GoPaperclip } from "react-icons/go";
const aichat =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/aichat.svg";
const aichatdownload =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/aichatdownload.svg";
const aichatbookmark =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/aichatbookmark.svg";
const aichatbot =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/aichatbox.svg";
export default function ({ sidebarCollapsed }) {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [isOptionsOpen, setIsOptionsOpen] = useState(false);
  return (
    <div
      className={`${isChatOpen ? "aichatmobileplacement" : ""} aichatholder`}
    >
      <div
        className={`${
          !isOptionsOpen ? "aichatoptionsclose" : ""
        } aichatoptions`}
      >
        <div
          className="aichatbubble"
          onClick={() => {
            setIsChatOpen(!isChatOpen);
            setIsOptionsOpen(false);
          }}
        >
          <img src={aichatbot} alt="AI Chat Bot" />
        </div>
        <div className="aichatbubble">
          <img src={aichatbookmark} alt="AI Chat Bookmark" />
        </div>
        <div className="aichatbubble">
          <img src={aichatdownload} alt="AI Chat Download" />
        </div>
      </div>
      <div
        className="aichatbutton"
        onClick={() => setIsOptionsOpen(!isOptionsOpen)}
      >
        <div className="aichatbuttoninner">
          <img src={aichat} alt="AI Chat" />
        </div>
      </div>
      <div
        className={`aichatbox ${!isChatOpen ? "aichatboxclose" : ""} ${
          sidebarCollapsed ? "aichatboxcollapsed" : "aichatboxmin"
        }`}
      >
        <div className="aichatboxleft">
          <input type="text" placeholder="Add Prompt Here" />
          <label htmlFor="aichatfile">
            <GoPaperclip />
          </label>
          <input type="file" id="aichatfile" style={{ display: "none" }} />
        </div>
        <div className="aichatboxright">
          <div className="aichatbubble">
            <FiSend />
          </div>
        </div>
      </div>
    </div>
  );
}
